import ProgressBar from "../components/ProgressBar";
import smile from './../../smile.svg';

function ScanInstruction({ details }) {
    return (
        <>
            <ProgressBar showProgressBar={true} percentage={details.percentage}></ProgressBar>
            <div className='mt-5 mb-10 font-mono text-2xl font-normal leading-8 text-center text-white w-full'>
                <h1 className="font-roboto text-[29px] font-bold leading-[36.25px] text-center mb-7">{details.title}</h1>

                <div className="flex justify-center mb-5">

                    <img
                        src={smile}
                        alt="Smile Image"
                        className="w-20 h-20 rounded-full border-2 border-gray-400"
                    />
                </div>

                <ul className="font-inter text-[17px] font-normal leading-[21.25px] text-left list-disc list-inside px-2">
                    {details.list.map((instruction, index) => (
                        <li className="list-outside pb-3" key={index}>{instruction}</li>
                    ))}
                </ul>

            </div>
        </>
    )
}
export default ScanInstruction;


